
var checkMobile = (rule, value, callback) => {
  if (!value) {
    return callback(new Error('手机号不能为空'))
  } else {
    const reg = /^1[3456789]\d{9}$/
    if (reg.test(value)) {
      callback()
    } else {
      return callback(new Error('请输入正确的手机号'))
    }
  }
}

var checkAge = (rule, value, callback) => {
  const reg = /^([1-9]\d?|100)$/
  if (reg.test(value)) {
    return callback()
  }
  // 返回一个错误提示
  callback(new Error('年龄输入错误'))
}

const sex = [
  {
    value: 1,
    label: '男'
  },
  {
    value: 2,
    label: '女'
  },
  {
    value: 0,
    label: '未知'
  }
]

const commonRules = {
  user_name: [
    { required: true, message: '请输入姓名', trigger: 'blur' }
  ],
  sex: [
    { required: true, message: '请选择性别', trigger: ['blur', 'change'] }
  ],
  age: [
    { required: true, message: '请输入年龄' },
    { type: 'number', message: '年龄必须为数字值' },
    { validator: checkAge, trigger: 'blur' }
  ],
  phone_number: [
    { required: true, message: '请输入手机号码', trigger: 'blur' },
    { validator: checkMobile, trigger: 'blur' }
  ],
  email: [
    { required: true, message: '请输入邮箱', trigger: 'blur' },
    { type: 'email', message: '请输入正确的邮箱', trigger: ['blur', 'change'] }
  ],
  highest_education: [
    { required: true, message: '请输入最高学历', trigger: ['blur'] }
  ]
}

const resume = {
  online: {
    active: '',
    con: [
      {
        title: '基本信息',
        parent: 'BasePar',
        template: 'BaseOn',
        mobileTem: 'MBaseOn',
        form: {
          sex: ''
        },
        sex,
        rules: {
          ...commonRules
        }
      },
      {
        title: '教育经历',
        template: 'Edu',
        mobileTem: 'MCurr',
        parent: 'EduPar',
        isAdd: true,
        type: 'education',
        education: [
          {
            value: '硕士',
            label: '硕士'
          }, {
            value: '本科',
            label: '本科'
          },
          {
            value: '大专',
            label: '大专'
          },
          {
            value: '大专以下',
            label: '大专以下'
          }
        ],
        education_type: [
          {
            value: '普通统招',
            label: '普通统招'
          },
          {
            value: '普通专插本',
            label: '普通专插本'
          },
          {
            value: '成人高考',
            label: '成人高考'
          },
          {
            value: '自考',
            label: '自考'
          },
          {
            value: '电大',
            label: '电大'
          },
          {
            value: '网络教育',
            label: '网络教育'
          }
        ],
        formList: [
          {}
        ],
        rules: {
          school: [
            { required: true, message: '请输入毕业院校', trigger: 'blur' }
          ],
          education: [
            { required: true, message: '请选择学历', trigger: ['blur', 'change'] }
          ],
          education_type: [
            { required: true, message: '请输入学历类型', trigger: ['blur', 'change'] }
          ],
          major: [
            { required: true, message: '请输入专业', trigger: 'blur' }
          ],
          date: [
            { required: true, message: '请输入起止时间', trigger: ['blur', 'change'] }
          ]
        }
      },
      {
        title: '工作经历',
        template: 'Work',
        mobileTem: 'MCurr',
        parent: 'WorkPar',
        type: 'work_experience',
        job_type: [
          {
            value: '全职',
            label: '全职'
          },
          {
            value: '实习',
            label: '实习'
          },
          {
            value: '兼职',
            label: '兼职'
          }
        ],
        formList: [
        ],
        rules: {
          company_name: [
            { required: true, message: '请输入公司名称', trigger: 'blur' }
          ],
          job: [
            { required: true, message: '请输入岗位名称', trigger: ['blur'] }
          ],
          job_type: [
            { required: true, message: '请选择岗位性质', trigger: ['blur', 'change'] }
          ],
          description: [
            { required: true, message: '请输入工作描述', trigger: 'blur' }
          ],
          date: [
            { required: true, message: '请输入起止时间', trigger: ['blur', 'change'] }
          ]
        },
        isAdd: true
      },
      {
        title: '项目经历',
        template: 'Project',
        mobileTem: 'MCurr',
        parent: 'ProjectPar',
        type: 'project_experience',
        formList: [
        ],
        rules: {
          project_name: [
            { required: true, message: '请输入项目名称', trigger: 'blur' }
          ],
          description: [
            { required: true, message: '请输入工作描述', trigger: 'blur' }
          ],
          date: [
            { required: true, message: '请输入起止时间', trigger: ['blur', 'change'] }
          ]
        },
        isAdd: true
      },
      {
        title: '等级证书',
        template: 'Grade',
        mobileTem: 'MGrade',
        parent: 'GradePar',
        type: 'certificates',
        formList: [
        ],
        rules: {
          certificate_name: [
            { required: true, message: '请输入证书名称', trigger: 'blur' }
          ],
          get_time: [
            { required: true, message: '请选择获取时间', trigger: ['blur', 'change'] }
          ]
        },
        isAdd: true
      },
      {
        title: '上传附件',
        template: 'Attach',
        mobileTem: 'MAttach',
        type: 'annex',
        formList: [
        ],
        isAdd: true
      }
    ]
  },
  upload: {
    active: '',
    con: [
      {
        title: '基本信息',
        parent: 'BasePar',
        template: 'BaseUp',
        mobileTem: 'MBaseUp',
        form: {
          sex: ''
        },
        sex,
        rules: {
          ...commonRules
        }
      },
      {
        title: '上传简历',
        template: 'Resume',
        mobileTem: 'MResume',
        form: {}
      },
      {
        title: '上传附件',
        template: 'AttachUp',
        mobileTem: 'MAttachUp',
        type: 'annex',
        formList: []
      }
    ]
  }
}

export default resume
